// login.ts
import client from './client';
import type { LoginResponse } from '../interfaces/LayoutInterface';

/**
 * POST /admin/login. The API identifies the caller from the MSAL token (TAS-667),
 * so no email is sent: with two Microsoft accounts cached, MSAL's first account can
 * differ from the token's, and the API rejects a mismatched email ("The signed-in
 * account does not match the requested email"). A `success:false` body is returned
 * as-is (its errorMessage is shown on the sign-in card). Transport / HTTP errors throw
 * an Error whose message is the server's text when it sent one; the caller shows
 * it, so nothing is alerted here.
 */
export const login = async (): Promise<LoginResponse> => {
  try {
    const response = await client.post('/admin/login', {});
    if (!response.data) {
      throw new Error("The server returned an empty login response.");
    }
    return response.data as LoginResponse;
  } catch (error: any) {
    console.error("Error logging in:", error);
    const data = error?.response?.data;
    const serverMessage =
      (typeof data?.errorMessage === 'string' && data.errorMessage) ||
      (typeof data?.message === 'string' && data.message) ||
      null;
    throw new Error(serverMessage || (error instanceof Error ? error.message : 'Failed to login.'));
  }
};
